export type AccentTone =
  | 'emerald'
  | 'amber'
  | 'blue'
  | 'rose'
  | 'indigo'
  | 'violet'
  | 'cyan'
  | 'orange';

export const ACCENT_TONE_VAR_CLASS: Record<AccentTone, string> = {
  emerald: '[--accent-tone:var(--palette-emerald)]',
  amber: '[--accent-tone:var(--palette-amber)]',
  blue: '[--accent-tone:var(--palette-blue)]',
  rose: '[--accent-tone:var(--palette-rose)]',
  indigo: '[--accent-tone:var(--palette-indigo)]',
  violet: '[--accent-tone:var(--palette-violet)]',
  cyan: '[--accent-tone:var(--palette-cyan)]',
  orange: '[--accent-tone:var(--palette-orange)]',
};

export const ACCENT_TONE_COLOR: Record<AccentTone, string> = {
  emerald: 'var(--palette-emerald)',
  amber: 'var(--palette-amber)',
  blue: 'var(--palette-blue)',
  rose: 'var(--palette-rose)',
  indigo: 'var(--palette-indigo)',
  violet: 'var(--palette-violet)',
  cyan: 'var(--palette-cyan)',
  orange: 'var(--palette-orange)',
};

export const ACCENT_SOFT_TILE_CLASS =
  'bg-[color-mix(in_oklab,var(--accent-tone)_12%,transparent)] text-(--accent-tone)';
